import script from "./OpdBillingReportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OpdBillingReportTable.vue?vue&type=script&setup=true&lang=js"

import "./OpdBillingReportTable.vue?vue&type=style&index=0&id=6377b35a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6377b35a"]])

export default __exports__